const style: any = (): any => ({
	fullWidth:{
		width: "100%",
	},
});

export default style;